/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isI18nData(obj) {
  return obj && obj.type === 'i18n';
}